const items = [
    {
        title: "2024-present",
        cardTitle: "HP Inc.",
        url: "https://www.hp.com",
        cardSubtitle: "March 2024 - Present",
        items: [
            {
                cardTitle: "Support Engineer II",
                cardSubtitle: "May 2024 - present",
                cardDetailedText: "Onboarding lead of SSO Authentication API (OAuth and SAML), coordinating with internal teams to ensure seamless integration; Troubleshooting technical issues, collaborating with product and engineering teams to identify, prioritize, and resolve critical problems, ensuring smooth operation and timely resolution.",
            },
            {
                cardTitle: "Support intern",
                cardSubtitle: "March 2024",
                cardDetailedText: "Functions: Act in engineering and software support projects; Technical meetings with teams’ projects; Technological solutions investigation for the software and engineering teams; Management of configuration and tools.",
            }
        ]
    },
    {
        title: "2019-2023",
        cardTitle: "Poza Cafe",
        url: "https://instagram.com/pozacafe/",
        cardSubtitle: "September 2019 - September 2023",
        items: [
            {
                cardTitle: "Co-owner",
                cardDetailedText: "I worked at a cafe for one year (from 2018 to 2019) as a barista and serving clientes. I fell in love with Specialty coffee and decided to open my own café. There I did a little bit of everything, focusing on the management and customer experience, attending 50-100 clients a day. Dealing with clients and undesrtanding their needs is something I really like and was already used to from my previous experiences. I could improve a lot of other skills I already had, such as organization, management, finances, problem-solving, and I grew up a lot both personally and professionally with this experience.",
            }
        ]
    },
    {
        title: "2013-2018",
        cardTitle: "Kuehne+Nagel",
        url: "https://home.kuehne-nagel.com/",
        cardSubtitle: "February 2013 - August 2018",
        items: [
            {
                cardTitle: "Road Transport Analyst",
                cardSubtitle: "Jul 2017",
                cardDetailedText: "In 2017 I was promoted to Road Transport Analyst and started working at the Mercosur team, with import and export transport, where I  was responsible for the shipment's daily follow-up with customers. From the pickup schedule to the final delivery. I was also responsible for document conference and issuance of road transport bill.",
            },
            {
                cardTitle: "Assistant Administrative",
                cardSubtitle: "Feb 2014",
                cardDetailedText: "In 2014 I was hired as an administrative assistant and in 2015, besides the tariff sector I started also being responsible for the cargo insurance. In that area I had constant contact with both inside and outside customers. I was responsible for the customer support when needed to activate the cargo insurance, that part was very delicate because I had to bring the bad news about the damaged cargo, so it required a good communication skill and empathy. I had to deal with problem solving and monthly reports. Since I had to manage two areas at the same time, I could improve abilities such as time management, organization, process optimization, and so on."
            },
            {
                cardTitle: "Trainee",
                cardSubtitle: "Feb 2013",
                cardDetailedText: "At Kuehne + Nagel I started in 2013 as an intern in the tariff sector. I was responsible for registering the freight negotiation values in the system for later issuance of the document for transportation.",
            },
        ]
    },
    {
        title: "2012-2013",
        cardTitle: "Zanatta",
        url: "https://zanattaseguros.com.br/",
        cardSubtitle: "January 2012 - February 2013",
        items: [
            {
                cardTitle: "Assistant Administrative",
                cardSubtitle: "May 2012",
                cardDetailedText: "When I was contracted as an assistant I was responsible for the renovation sector, where I contacted customers one week prior to the insurance expiration date to update and confirm their data, then I organized and distributed the proposals to the team and also did some quotations and then passed them on to the sales team.",
            },
            {
                cardTitle: "Trainee",
                cardSubtitle: "Jan 2012",
                cardDetailedText: "As an intern, I was responsible for contacting new customers to collect data so that I could have all the information needed to calculate the insurance.",
            },
        ]
    }
]

export { items }